import { useEffect, useRef } from "react";

const Logo = ({ darkMode }: { darkMode: boolean }) => {
  const svgRef = useRef<HTMLObjectElement>(null);
  useEffect(() => {
    if (svgRef.current) {
      const svgObject = svgRef.current;
      svgObject.onload = () => {
        // Get the SVG element from the object
        const svgDoc = svgObject.contentDocument;
        if (svgDoc) {
          const svgElement = svgDoc.querySelector('svg');
          if (svgElement && window.__SVGATOR_PLAYER__?.['91c80d77']?.[0]?.player) {
            window.__SVGATOR_PLAYER__['91c80d77'][0].player.play();
          }
        }
      };
    }
  }, []);

  return (
    <object
      ref={svgRef}
      aria-label="Julian Querido Logo"
      data={darkMode ? '/dark-logo.svg' : '/light-logo.svg'}
      type="image/svg+xml"
      className="h-6 w-auto pointer-events-none"
      style={{ colorScheme: 'light' }}
    />
  );
};

export default Logo;